import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { Role } from 'my-lib-sanfelici';
import { RolesService } from 'my-lib-sanfelici';



@Component({
  selector: 'app-roles-create',
  templateUrl: './roles-create.component.html',
  styleUrls: ['./roles-create.component.css']
})
export class RolesCreateComponent implements OnInit {
role: Role;
  constructor(
    private router: Router,
    private rolesservice: RolesService) {this.role = {Name: null} }
salva() {

}
submit() {
  const r = this.role;
  this.rolesservice.create(r.Name,this.role);
  this.router.navigate(['/roles']);
}
  ngOnInit() {
  }

}
